export default {
  fields: {
    name: 'Name',
    email: 'E-Mail Address',
    password: 'Password',
    confirm_password: 'Confirm your password',
    phone: 'Phone',
    status: 'Status',
    doc_type: 'Doc type',
    document: 'Document',
    vehicle: 'Vehicle',
    plate: 'Licence number',
    color: 'Color',
    soat_exp: 'Soat',
    tec_exp: 'Techno',
    balance: 'Balance',
    payment_mode: 'Payment mode',
    photo: 'Profile photo'
  },
  actions: {
    send_message_to_all: 'Send message to all drivers',
    send_message_to: 'Send message to {name}',
    sent_success: 'Message sent successfully',
  },
  forms: {
    edit: 'Edit driver information',
    create_title: 'Create driver',
    create_driver: 'Driver information',
    upload: 'Upload photo profile',
    upload_vehicle: 'Upload photo vehicle',
    current_balance: 'Current balance',
    manage_balance: 'Manage',
    recharge_note: 'Note (optional)',
    recharge_note_placeholder: 'e.g. efectivo, transferencia...',
    manage_balance_title: 'Manage balance',
    adjustment_type: 'Adjustment type',
    adjustment_add: 'Add',
    adjustment_subtract: 'Deduct',
    amount_cop: 'Amount (COP)',
    amount_placeholder: 'e.g. 5000',
    adjustment_note_placeholder: 'Adjustment reason...',
    apply_adjustment: 'Apply adjustment',
  },
  vehicle: {
    brand: 'Brand',
    model: 'Model',
    plate: 'Licence plate number',
    color: 'Color',
    soat_exp: 'Soat',
    tec_exp: 'Techno'
  },
  placeholders: {
    password: 'Password',
    confirm_password: 'Confirm password',
    docType: 'Document Type',
    document: 'Enter Document number',
    brand: 'Enter car brand',
    model: 'Enter car model',
    plate: 'Enter licence plate number',
    photo: 'Choose photo profile',
    photo_hint: 'Optional · JPG or PNG',
    photo_vehicle: 'Choose photo vehicle',
    color: 'Choose color vehicle',
    soat_exp: 'Choose Soat expiration',
    tec_exp: 'Choose Techno expiration',
    search: 'Search'
  },
  filters: {
    add_filter: '+ Add filter',
    filter_search: 'Search',
    filter_status: 'Status',
    filter_payment: 'Payment',
    filter_payment_status: 'Payment status',
    filter_period: 'Period',
    filter_inactive: 'Inactivity',
    filter_needs_vehicle: 'Needs vehicle',
    chip_status: 'Status: {value}',
    chip_payment: 'Payment: {value}',
    chip_inactive: 'Inactive > {days}d',
    chip_needs_vehicle: 'Needs vehicle',
    inactive_none: 'None',
    inactive_days: '{days}d',
    custom: 'Custom',
    custom_placeholder: 'Days',
    status_values: {
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    payment_values: {
      monthly: 'Monthly',
      percentage: 'Percentage',
    },
    payment_status_values: {
      paid: 'Paid',
      pending: 'Pending',
    },
    payment_status_percentage_hint: 'Not applicable for percentage-paid drivers',
  },
  bulk: {
    selected: 'selected',
    disable_confirm: 'Disable {count} driver(s)? This action will revoke their access.',
    enable_result: '{processed} enabled · {failed} failed',
    disable_result: '{processed} disabled · {failed} failed',
    send_result: '{processed} sent · {failed} failed',
  },
  recharges: {
    history_title: 'Balance History',
    col_date: 'Date',
    col_amount: 'Amount',
    col_balance: 'Resulting Balance',
    col_actor: 'Registered by',
    col_note: 'Note',
  },
  monthly_payments: {
    open_modal: 'Register Monthly Payment',
    modal_title: 'Register monthly payment',
    field_period: 'Period',
    hint_period: 'Defaults to the current month. For past months, select the corresponding period.',
    field_amount: 'Amount (COP)',
    hint_amount: 'Amount ≥ 0. Pre-filled from the configured suggested amount.',
    field_note: 'Note (optional)',
    placeholder_note: 'Notes...',
    info_registered_by: 'The payment will be registered under {name} with the current date and time.',
    action_register: 'Register',
    history_title: 'Monthly Payment History',
    col_period: 'Period',
    col_amount: 'Amount',
    col_actor: 'Registered by',
    col_date: 'Date',
    col_note: 'Note',
    col_status: 'Status',
    action_void: 'Void',
    void_modal_title: 'Void monthly payment',
    field_void_reason: 'Void reason',
    placeholder_void_reason: 'Explain the reason for voiding...',
    action_void_confirm: 'Confirm void',
    badge_voided: 'Voided',
    voided_by: 'Voided by {name}',
  },
  detail: {
    section_vehicles: 'Assigned vehicles',
    section_device: 'Device',
    section_status_payments: 'Status and payments',
    section_history: 'History',
    tab_saldo: 'Balance',
    tab_mensualidades: 'Monthly payments',
    empty_recharges: 'No balance movements',
    empty_monthly_payments: 'No monthly payments recorded',
    count_movements: '{n} movement | {n} movements',
    count_monthly: '{n} monthly payment | {n} monthly payments',
  },
  payments_audit: {
    title: 'Payments audit',
    entry_label: 'Payments',
    tabs: {
      monthly: 'Monthly payments',
      recharges: 'Recharges',
    },
    mode: {
      detail: 'Detail',
      summary: 'Summary by driver',
    },
    filters: {
      filter_period: 'Period',
      period_all: 'All periods',
      filter_created_from: 'Registered from',
      filter_created_to: 'Registered to',
      filter_driver_search: 'Search driver',
      placeholder_driver_search: 'Name, document or plate',
      filter_actor: 'Registered by',
      filter_status: 'Status',
      filter_amount_threshold: 'Amount threshold',
      filter_min_amount: 'Min amount',
      filter_max_amount: 'Max amount',
      filter_anomalies: 'Anomalies',
      clear_filters: 'Clear filters',
    },
    anomalies: {
      duplicate: 'Duplicate',
      possible_duplicate: 'Possible duplicate',
      atypical: 'Atypical',
      out_of_period: 'Out of period',
      voided: 'Voided',
    },
    monthly: {
      col_driver: 'Driver',
      col_period: 'Period',
      col_amount: 'Amount',
      col_actor: 'Registered by',
      col_date: 'Date',
      col_note: 'Note',
      col_anomalies: 'Anomalies',
      col_status: 'Status',
      col_actions: 'Actions',
    },
    recharges: {
      col_driver: 'Driver',
      col_month: 'Month',
      col_amount: 'Amount',
      col_balance_before: 'Balance before',
      col_balance_after: 'Balance after',
      col_actor: 'Registered by',
      col_date: 'Date',
      col_note: 'Note',
      col_anomalies: 'Anomalies',
    },
    summary: {
      col_driver: 'Driver',
      col_active_amount: 'Active amount',
      col_payment_count: 'Payment count',
      col_voided_count: 'Voided',
      col_duplicate_count: 'Duplicates',
      col_atypical_count: 'Atypical',
      col_out_of_period_count: 'Out of period',
      col_last_created_at: 'Last registration',
    },
    totals: {
      active_amount: 'Active amount',
      active_count: 'Active payments',
      voided_count: 'Voided',
      active_driver_count: 'Active drivers',
    },
    totals_hint: 'These totals match the metrics dashboard revenue figures for the same period. The dashboard refreshes daily.',
    recharges_readonly_hint: 'Recharges are immutable. To correct a mistake, register a compensating recharge from the driver view.',
    driver_chip: 'Driver: {name}',
    empty: 'No results for the selected filters',
  },
}
